import { useEffect } from "react";
const { REACT_APP_LIVE_CHAT_URL } = process.env;

export const useLiveChat = () => {
  const initLiveChat = () => {
    // var Tawk_API = Tawk_API || {}, Tawk_LoadStart = new Date();
    (function () {
      var s1 = document.createElement("script"),
        s0 = document.getElementsByTagName("script")[0];
      s1.async = true;
      s1.src = REACT_APP_LIVE_CHAT_URL;
      s1.charset = "UTF-8";
      s1.setAttribute("crossorigin", "*");
      s0.parentNode.insertBefore(s1, s0);
      s0.parentNode.insertBefore(s1, s0);
    })();
  };

  useEffect(() => {
    initLiveChat();
  }, []);
};
